/** @prettier */
import PropTypes from 'prop-types';
import React, { Fragment } from 'react';
import { Trans } from 'react-i18next';

import Button from '@xanadu/ui-shared/components/widgets/Button';
import DropdownField from '@xanadu/ui-shared/components/widgets/DropdownField';
import { useImprovedTranslation } from '@xanadu/ui-shared/hooks';

const KycCashierRestricted = ({
  isDesktop,
  showJobTitle,
  jobTitle,
  jobTitleError,
  onJobTitleChange,
  closeModal,
  uploadDocuments,
  redirectToApps,
  styledClientName,
  styles,
  IS_MOBILE,
  OCCUPATION_LIST,
  liveChatEnabled,
}) => {
  const { t } = useImprovedTranslation();

  const isButtonDisabled = showJobTitle && !jobTitle;

  return (
    <Fragment>
      <div>
        <div className={styles.modalTitle}>{t('Cashier Restricted - Verification Needed')}</div>
        <div className={styles.bold}>
          {t(
            'Your cashier has been restricted pending additional account verification. To complete verification please provide the following'
          )}
          :
        </div>
        {showJobTitle ? (
          <DropdownField
            fluid={IS_MOBILE}
            label={t('Occupation')}
            name="occupation"
            theme="dark"
            textAlign="left"
            items={OCCUPATION_LIST}
            value={jobTitle}
            onPropertyChange={onJobTitleChange}
            placeholder={t('Select an option')}
          />
        ) : (
          <ul className={styles.list}>
            <li>{t('Proof of Identity')}</li>
            <li>{t('Proof of Address')}</li>
          </ul>
        )}
        <div>
          <span>
            {t(
              'An email has been sent to your registered email address, outlining the information we require.'
            )}
          </span>
          <br />
          <br />
          <span>
            <Trans i18nKey="If you have submitted the documents already via email, please do not resubmit your documents and await feedback from the site Compliance team.">
              If you have submitted the documents already via email, please do not resubmit your
              documents and await feedback from the {styledClientName} Compliance team.
            </Trans>
          </span>
          <br />
          <br />
          <span>
            {liveChatEnabled
              ? t('Our customer service team is on hand to help with your account via Live Chat.')
              : t('Our customer service team is on hand to help with your account via email.')}
          </span>
        </div>
      </div>
      <div className={styles.containerActions}>
        <Button sizeType="wider" buttonType="flat" onClick={closeModal}>
          {t("I'll do it later")}
        </Button>
        {isDesktop ? (
          <Button
            sizeType="wider"
            buttonType="primary"
            onClick={uploadDocuments}
            className={styles.primaryButton}
            disabled={isButtonDisabled}
          >
            {t('Upload Documents')}
          </Button>
        ) : (
          <Button
            sizeType="wider"
            buttonType="primary"
            onClick={redirectToApps}
            className={styles.primaryButton}
            disabled={isButtonDisabled}
          >
            {t('Get the App')}
          </Button>
        )}
      </div>
      {jobTitleError && <div className={styles.error}>{jobTitleError}</div>}
    </Fragment>
  );
};

KycCashierRestricted.propTypes = {
  showJobTitle: PropTypes.bool.isRequired,
  onJobTitleChange: PropTypes.func.isRequired,
  closeModal: PropTypes.func.isRequired,
  uploadDocuments: PropTypes.func.isRequired,
  redirectToApps: PropTypes.func.isRequired,
  isDesktop: PropTypes.bool.isRequired,
  styledClientName: PropTypes.oneOfType([PropTypes.string, PropTypes.node]).isRequired,
  jobTitle: PropTypes.string,
  jobTitleError: PropTypes.string,
  styles: PropTypes.any.isRequired,
  IS_MOBILE: PropTypes.bool.isRequired,
  OCCUPATION_LIST: PropTypes.array.isRequired,
  liveChatEnabled: PropTypes.bool.isRequired,
};

export default KycCashierRestricted;
